import { computed, inject, type ComputedRef } from 'vue'

export type CardContext = {
  isLoading: boolean
}

export const useCard = (): {
  context: ComputedRef<CardContext>
} => {
  const cardContext = inject<ComputedRef<CardContext>>(
    'cardContext',
    computed(() => {
      return { isLoading: false }
    }),
  )

  return {
    context: cardContext,
  }
}
